import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import TimerDisplay from '../TimerDisplay';
import { Palette } from 'Palette';
import { StyledTypography } from '../styles/styles';

interface HeaderImpersonationBannerProps {
  impersonatingName: string;
  impersonationExpires?: number;
  captureLogs?: boolean;
  onExit: () => void;
}

const HeaderImpersonationBanner: React.FC<HeaderImpersonationBannerProps> = ({
  impersonatingName,
  impersonationExpires,
  captureLogs,
  onExit,
}) => (
  <Box sx={{ textAlign: 'center', width: '100%' }}>
    <StyledTypography variant="body2" color="warning.main">
      Viewing as {impersonatingName}{' '}
      {captureLogs && (
        <Typography component="span" variant="caption" data-testid="impersonation-with-logs">
          with logs{' '}
        </Typography>
      )}
      {impersonationExpires && (
        <TimerDisplay
          prefixLabel={{
            normal: 'Expires in',
            urgent: 'Window will close in',
          }}
          urgentWithSecondsLeft={120}
          impersonationExpires={impersonationExpires}
          onExpired={onExit}
        />
      )}
      <Button
        size="small"
        color="inherit"
        onClick={onExit}
        sx={{
          textTransform: 'none',
          borderRadius: '999px',
          border: `1px solid ${Palette.warning.background}`,
          backgroundColor: Palette.warning.buttonBg,
          color: Palette.warning.buttonText,
          ml: 1,
        }}
      >
        Exit
      </Button>
    </StyledTypography>
  </Box>
);

export default HeaderImpersonationBanner;
